
angular.module('bmsApp.calendar', [
	'ui.router'
])
	.config([
		'$stateProvider', function config(
			$stateProvider
			) {

			$stateProvider

				.state('breakout.calendar', {
					url: '^/calendar',
					views: {
						'main@breakout': {
							templateUrl: "ng/calendar/templates/Calendar.html",
							controller: 'CalendarCtrl'
						}
					},
					ncyBreadcrumb: {label: 'Calendar'}
				})

				;

		}]);
